import router from "@/router/index";
import { useRouteStore } from "@/stores/routeStore";
import { reloadRoutesFromSessionStorage } from "@/utils/routeUtils";

// 常量定义
const WHITE_LIST = ["/login", "/"];

// 检查是否在白名单中
const isInWhiteList = (path) => WHITE_LIST.includes(path);

// 初始化动态路由
const initDynamicRoutes = async (routeStore, menuList) => {
  await routeStore.initRoutes(menuList);
  routeStore.setRoutesState(true);
  routeStore.dynamicRoutes.forEach((route) => {
    router.addRoute(route);
  });
  await reloadRoutesFromSessionStorage();
};

// 导航守卫
router.beforeEach(async (to, from, next) => {
  const routeStore = useRouteStore();
  const token = window.sessionStorage.getItem("token");
  const menuList = JSON.parse(sessionStorage.getItem("menuList"));
  const hasRoutes = routeStore.hasRoutes;

  if (token) {
    if (!hasRoutes) {
      try {
        await initDynamicRoutes(routeStore, menuList);
        next(to.fullPath);
      } catch (error) {
        next("/login"); // 如果初始化失败，跳转到登录页
      }
    } else {
      next();
    }
  } else {
    if (isInWhiteList(to.path)) {
      next();
    } else {
      next("/login");
    }
  }
});
